export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // TWO FACTOR AUTHENTICATION
  'component.twoFactorAuth.modal.title': '设置 2FA 验证',
  'component.twoFactorAuth.modal.success': '成功激活 2FA',
  'component.twoFactorAuth.modal.button.close': '关闭',
  'component.twoFactorAuth.modal.subTitle': '您将被登出',
  'component.twoFactorAuth.modal.submitBtn': '提交',
  'component.twoFactorAuth.modal.form.input.placeholder': '输入您的应用程序中的验证码。',
  'component.twoFactorAuth.modal.form.input.label': '2FA 验证码',
  'component.twoFactorAuth.modal.form.input.rules.required': '请输入验证',
  'component.twoFactorAuth.modal.form.input.rules.invalid': '验证码错误，请重新输入。',
  'component.twoFactorAuth.modal.qr.error': '生成 2FA 二维码失败',
  'component.twoFactorAuth.modal.enable.error': '启用双重验证失败',

  // API Key Generate
  'component.apiKey.modal.copy.message': 'API 密钥已复制到剪贴板！',
  'component.apiKey.modal.alert.warning':
    '复制此钥以访问 ZPayment API。为了安全起见，不会再次显示。',
  'component.apiKey.modal.alert.info': '单击令牌或复制按钮将 API 密钥复制到剪贴板。',
  'component.apiKey.modal.button.copy': '复制',
  'component.apiKey.modal.button.generate': '生成 API Key',
  'component.apiKey.modal.2fa.error': '请输入有效的 6 位数代码',
  'component.apiKey.modal.2fa.invalid': '2FA 代码无效',

  'component.apiKey.modal.2fa.title': '2FA验证',
  'component.apiKey.modal.2fa.description': '请输入您的2FA代码以生成API密钥',

  // API key HOC
  'component.apiKeyHoc.label': '生成 API 密钥',
  'component.apiKeyHoc.success': 'API 密钥已删除！',
  'component.apiKeyHoc.error': '删除 API 密钥失败，请重试！',

  // API Key Table
  'component.apiKeyTable.column.no': '编号',
  'component.apiKeyTable.column.apiKey': 'API 密钥',
  'component.apiKeyTable.column.createdAt': '创建于',
  'component.apiKeyTable.column.action': '操作',
  'component.apiKeyTable.column.action.confirmation': '您确定要删除此记录吗？',
  'component.apiKeyTable.column.action.confirmation.okText': '是',
  'component.apiKeyTable.column.action.confirmation.cancelText': '否',
  'component.apiKeyTable.column.action.delete': '删除',
  'component.apiKeyTable.title': 'API 密钥历史',

  // Webhook Api Key
  'component.webhookApiKey.label': '回调密钥',
  'component.webhookApiKey.modal': '回调密钥',
  'component.webhookApiKey.copy.error': 'API 密钥已复制到剪贴板',
  'component.webhookApiKey.copy.success': `抱歉，无法复制 API 密钥！`,
  'component.webhookApiKey.button.generate': '产生',
  'component.webhookApiKey.button.regenerate': '再生',
  'component.webhookApiKey.button.copy': '复制',
  'component.webhookApiKey.modal.alert.warning':
    '复制此令牌以访问 ZPayment API。为了安全起见，不会再次显示。',
  'component.webhookApiKey.modal.alert.info': '单击令牌或复制按钮将 API 密钥复制到剪贴板。',
  'component.webhookApiKey.input.placeholder': '空',
  'component.withdrawRequestStatus.button.edit': '编辑',

  // Tron Energy Settings
  'component.tronEnergySettings.updateSuccess': '波场能量租赁设置更新成功',
  'component.tronEnergySettings.updateError': '更新波场能量租赁设置失败',
  'component.tronEnergySettings.label': '波场能量租赁设置',
  'component.tronEnergySettings.tooltip': '启用或禁用波场能量租赁用于归集操作',
  'component.tronEnergySettings.consolidateFee.label': '手续费归集能量租赁',
  'component.tronEnergySettings.consolidateFee.tooltip':
    '启用后，系统将为归集手续费操作租用波场能量',
  'component.tronEnergySettings.consolidateFund.label': '启用资金归集能量租赁',
  'component.tronEnergySettings.consolidateFund.tooltip':
    '启用后，系统将为归集资金操作租用波场能量',

  // Create Sub User Form
  'component.createSubUserForm.form.label.firstName': '名',
  'component.createSubUserForm.form.label.lastName': '姓',
  'component.createSubUserForm.form.label.email': '电子邮件',
  'component.createSubUserForm.form.label.password': '密码',
  'component.createSubUserForm.form.button.create': '创建子账号',
  'component.createSubUserForm.form.success': '子账号创建成功',
  'component.createSubUserForm.form.error': '创建子账号失败',
  'component.createSubUserForm.form.rules.email': '请输入电子邮件',
  'component.createSubUserForm.form.rules.password': '请输入密码',
  'component.createSubUserForm.form.rules.password.uppercase': '密码必须包含至少一个大写字母',
  'component.createSubUserForm.form.rules.password.lowercase': '密码必须包含至少一个小写字母',
  'component.createSubUserForm.form.rules.password.number': '密码必须包含至少一个数字',
  'component.createSubUserForm.form.label.twoFactorCode': '2FA 验证码',
  'component.createSubUserForm.form.rules.twoFactorCode': '请输入 2FA 验证码',

  // Webhook Url Input
  'component.webhookUrlInput.label': '回调网址',
  'component.webhookUrlInput.modal.placeholder': '2FA 验证码',
  'component.withdrawWebhookUrlInput.label': '提现回调网址',
  'component.webhookUrlInput.error.invalid': '无效的网址',
  'component.webhookUrlInput.success': '回调网址更新成功',
  'component.webhookUrlInput.error.updateFailed': '更新失败',
  'component.webhookUrlInput.error.incorrectTwoFactorCode': '2FA 代码不正确',
  'component.webhookUrlInput.modal.title': '2FA 验证码',
  'component.webhookUrlInput.field.placeholder': '回调网址',
  'component.withdrawWebhookUrlInput.field.placeholder': '提现回调网址',

  // Email Input With Button
  'component.emailInputWithButton.label': '通知电子邮件',
  'component.emailInputWithButton.success': '通知电子邮件更新成功！',
  'component.minPayout.label': '最低自动归集USDT金额',

  // Fee rate
  'component.feeRateInput.label': '手续费率 %',
  'component.feeRateInput.modal.title': '输入 2FA 代码',
  'component.feeRateInput.field.placeholder': '输入 2FA 代码',

  // Withdraw Request Statusa
  'component.withdrawRequestStatus.label': '开始提款请求审核功能',
  'component.withdrawRequestStatus.success': '提款请求设置已成功更新！',
  'component.withdrawRequestStatus.error': '无法更新提款请求设置！',
  'component.withdrawRequestStatus.enabled.description':
    '如果金额小于或等于 {amount} USDT，提款请求将自动批准。',
  'component.withdrawRequestStatus.modal.title': '设置自动批准金额',
  'component.withdrawRequestStatus.modal.description':
    '输入自动批准的最大金额。超过此金额的请求将需要手动批准。',
  'component.withdrawRequestStatus.modal.input.placeholder': '输入金额',
  'component.withdrawRequestStatus.riskWarning':
    '请注意，自动批准提款请求可能存在风险。请谨慎设置自动批准金额阈值',
  'component.withdrawRequestStatus.threshold.label': '自动批准金额 (USDT)',
  'component.withdrawRequestStatus.basicRiskAssessment.label': '基本风险评估',
  'component.withdrawRequestStatus.customRiskAssessment.tooltip':
    '如果提款地址之前未被使用过，则需要手动审批以进行安全验证',
  'component.withdrawRequestStatus.customRiskAssessment.label': '风险评估 - 参考检查',
  'component.withdrawRequestStatus.riskAssessment.success': '风险评估设置已成功更新',
  'component.withdrawRequestStatus.riskAssessment.error': '无法更新风险评估设置',
  'component.withdrawRequestStatus.prefixLength.value': '地址前缀长度: {length}',
  'component.withdrawRequestStatus.referenceCheck.modal.title': '设置参考检查',
  'component.withdrawRequestStatus.referenceCheck.preview.description':
    '此功能通过比对引用备注前缀来检查提款地址是否曾被使用过。如果该地址没有提款历史记录，将需要手动审批以增强安全性',
  'component.withdrawRequestStatus.referenceCheck.preview.title': '参考备注检查：',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.required':
    '请输入备注前缀长度',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.placeholder':
    '输入备注前缀长度',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.label': '备注前缀长度',

  // Withdraw Request Page
  'withdrawRequests.page.fetch.error': '获取提款请求失败',
  'withdrawRequests.page.approve.success': '提款请求批准成功！',
  'withdrawRequests.page.approve.error': '批准提款请求失败,请稍后再重试',
  'withdrawRequests.page.reject.success': '提款请求拒绝成功！',
  'withdrawRequests.page.reject.error': '拒绝提款请求失败',
  'withdrawRequests.page.table.column.number': '编号',
  'withdrawRequests.page.table.column.fromAddress': '发件地址',
  'withdrawRequests.page.table.column.toAddress': '收件地址',
  'withdrawRequests.page.table.column.amount': '金额',
  'withdrawRequests.page.table.column.reference': '参考',
  'withdrawRequests.page.table.column.timestamps': '时间戳',
  'withdrawRequests.page.table.column.token': '代币',
  'withdrawRequests.page.table.column.network': '网络',
  'withdrawRequests.page.table.column.status': '状态',
  'withdrawRequests.page.table.column.action': '操作',
  'withdrawRequests.page.table.action.approve': '批准',
  'withdrawRequests.page.table.action.reject': '拒绝',
  'withdrawRequests.page.table.column.remark': '备注',
  'withdrawRequests.page.table.column.automated': '自动通过',
  'withdrawRequests.page.table.automationRemark': '自动通过: 金额低于等于 {number}', // Auto-approved: Amount below threshold {number}
  'withdrawRequests.modal.approve.title': '批准提款请求',
  'withdrawRequests.modal.reject.title': '拒绝提款请求',
  'withdrawRequests.modal.approve.content': '您确定要批准此提款请求吗？',
  'withdrawRequests.modal.reject.content': '您确定要拒绝此提款请求吗？',
  'component.withdrawRequestStatus.modal.input.rules.required': '请输入金额',
  'component.withdrawRequestStatus.modal.input.validation': '金额必须在 0 到 500,000 之间',

  // Transactions Page
  'transactions.table.column.tx': '交易',
  'transactions.table.column.id': '序号',
  'transactions.table.column.from': '来源',
  'transactions.table.column.to': '目标',
  'transactions.table.column.transferDirection': '转账方向',
  'transactions.table.column.network': '网络',
  'transactions.table.column.amount': '金额',
  'transactions.table.column.date': '日期',
  'transactions.table.column.fee': '手续费',
  'transactions.table.column.fee.short': '手续费',
  'transactions.table.column.time': '时间戳',
  'transactions.table.column.time.short': '时间',
  'transactions.table.column.afterFee': '手续费后金额',
  'transactions.table.column.afterFee.short': '实收',
  'transactions.table.button.export': '导出',
  'transactions.table.select.placeholder': '选择转账方向',
  'transactions.table.content.from': '来自',
  'transactions.table.content.to': '至',
  'transactions.table.error.export': '导出交易失败',
  'transactions.table.error.fetch': '获取交易失败',

  // CSV导出
  'csv.export.modal.title': '正在导出数据',
  'csv.export.modal.cancel': '取消导出',
  'csv.export.modal.progress': '正在处理第 {current} 页，共 {total} 页...',
  'csv.export.modal.records': '已处理 {processed} 条记录，共 {total} 条',
  'csv.export.modal.large.warning': '正在进行大型导出',
  'csv.export.modal.large.description': '此导出包含大量记录。请耐心等待，不要关闭此窗口。',
  'csv.export.modal.note': '请保持此窗口打开，直到导出完成。',
  'csv.export.cancel.confirm.title': '取消导出',
  'csv.export.cancel.confirm.content': '确定要取消导出吗？进度将会丢失。',
  'csv.export.cancel.confirm.ok': '是的，取消',
  'csv.export.cancel.confirm.cancel': '继续导出',
  'csv.export.success': '数据导出成功！',
  'csv.export.error': '导出数据失败，请重试。',
  'csv.export.warning.title': '大型导出警告',
  'csv.export.warning.content': '您即将导出 {count} 条记录。这可能需要几分钟时间。您要继续吗？',
  'csv.export.warning.continue': '继续导出',
  'csv.export.warning.cancel': '取消',
  'csv.export.error.no_data': '未从服务器收到数据',
  'csv.export.error.too_many_records':
    '记录过多 ({count})。最大允许数量为 {max}。请缩小搜索条件。',
  'csv.export.error.cancelled': '用户取消了导出',
  // Export date range limit
  'transactions.export.limit.note': '导出数据最多支持 3 个月范围，请缩小日期范围。',
  'transactions.export.limit.short': '导出最多 3 个月的数据',
  'transactions.export.no_data': '当前筛选条件下没有可导出的数据',
  'transactions.export.max_records': '未设置筛选条件：将导出最多 10,000 条记录',
  'consolidate_fee_logs.export.no_data': '当前筛选条件下没有可导出的手续费数据',
  'consolidate_logs.export.no_data': '当前筛选条件下没有可导出的归集数据',

  // API Key V2
  'component.apiKeyTable.column.name': '名称',
  'component.apiKeyTable.column.active': '活跃',
  'component.apiKeyTable.delete.confirm': '您确定要删除此 API 密钥吗？',
  'component.apiKeyTable.delete.confirm.yes': '是',
  'component.apiKeyTable.delete.confirm.no': '否',
  'component.apiKeyTable.delete.button': '删除',
  'component.apiKeyTable.delete.success': 'API 密钥已成功删除!',

  'component.v2ApiKeyGenerate.success': 'API 密钥创建成功',
  'component.v2ApiKeyGenerate.createError': '创建 API 密钥失败',
  'component.v2ApiKeyGenerate.button.open': '生成密钥',
  'component.v2ApiKeyGenerate.modal.title': '生成的 API 密钥',
  'component.v2ApiKeyGenerate.modal.button.create': '创建 API 密钥',
  'component.v2ApiKeyGenerate.modal.alert.warning': '不要与任何人分享您的私钥，甚至包括我们！',
  'component.v2ApiKeyGenerate.publicKey': '公钥',
  'component.v2ApiKeyGenerate.apiKey': '您的 API 密钥，请妥善保存，不会再次显示！',

  // Merchant Consolidation
  'component.merchantConsolidation.addWalletFirst': '请先添加手续费钱包以启用归集。',
  'component.merchantConsolidation.toggle.success': '归集设定更新成功',
  'component.merchantConsolidation.toggle.error': '更新归集设定失败',
  'component.merchantConsolidation.feeWallet.label': '手续费归集到自设钱包',
  'component.merchantConsolidation.noFeeWalletsMessage': '未配置手续费钱包。请添加钱包以启用归集。',
  'component.merchantConsolidation.noWalletsMessage': '未配置手续费钱包。请添加钱包以启用归集。',
  'component.merchantConsolidation.enabledDescription': '自动将交易手续费归集到已配置的钱包。',
  'component.merchantConsolidation.disabledDescription': '当前已禁用。请启用以开始归集到自设钱包。',
  'component.merchantConsolidation.manageWalletsButton': '设置钱包',
  'component.merchantConsolidation.2fa.modal.title': '输入二次验证码以确认操作',
  'common.confirm': '确认',
  'component.merchantConsolidation.2fa.label': '二次验证码 (2FA)',
  'component.merchantConsolidation.2fa.required': '请输入您的二次验证码',
  'component.merchantConsolidation.2fa.length': '二次验证码必须为6位数',
  'component.merchantConsolidation.2fa.placeholder': '输入6位数的二次验证码',
  'component.merchantConsolidation.label': '归集钱包设置',
  'component.addMerchantWallet.addWallet.success': '手续费钱包添加成功',
  'component.addMerchantWallet.addWallet.error': '添加手续费钱包失败',
  'component.addMerchantWallet.modal.manageWalletsTitle': '管理手续费钱包',
  'component.addMerchantWallet.modal.addWalletButton': '添加钱包',
  'settings.consolidation.updateWallets.success': '钱包更新成功',
  'settings.consolidation.configureWalletsTitle': '配置归集钱包',
  'settings.consolidation.saveButton': '保存更改',
  'settings.consolidation.notSet': '未设置',
  'settings.consolidation.updateWallets.error': '更新钱包失败',
  'settings.consolidation.updateWallets.modal.title': '确认钱包更新',
  'settings.consolidation.updateWallets.modal.prompt': '请输入您的二次验证码以更新归集钱包。',
  'settings.consolidation.updateWallets.modal.cancel': '取消',
  'settings.consolidation.updateWallets.modal.confirm': '确认更新',
  'settings.consolidation.clearAddress': '清除',
  'settings.consolidation.editAddress': '编辑',
  'settings.consolidation.addressHelpText': '如果您不想为此网络设置钱包，请留空。',
  'component.addMerchantWallet.warning.title': '重要安全提示',
  'component.addMerchantWallet.warning.description':
    '请仔细核对所有钱包地址。错误的地址将导致资金永久损失。',
  'component.addMerchantWallet.network.label': '网络',
  'component.addMerchantWallet.network.placeholder': '选择网络',
  'component.addMerchantWallet.address.label': '钱包地址',
  'component.addMerchantWallet.address.placeholder': '输入钱包地址',
  'component.addMerchantWallet.2fa.label.addWallet': '二次验证码（用于添加钱包）',
  'component.addMerchantWallet.2fa.required.addWallet': '请输入您的二次验证码以添加钱包',
  'component.addMerchantWallet.2fa.length': '二次验证码必须为6位数',
  'component.addMerchantWallet.2fa.placeholder.addWallet': '输入6位数的二次验证码',
  'component.merchantWallets.noWalletsMessage': '没有现有钱包',
  'component.merchantWallets.noWalletsDescription':
    '未配置归集手续费钱包。请添加钱包以启用归集到自设钱包功能。',
  'component.merchantWallets.currentFeeWalletsTitle': '当前手续费钱包',
  'component.addMerchantWallet.2fa.label.updateWallets': '二次验证码',
  'component.addMerchantWallet.modal.saveButton': '保存',
  'component.addMerchantWallet.clickEditToChange': '点击编辑按钮以更改',
  'component.addMerchantWallet.modal.configureWalletsTitle': '配置归集钱包',
  'component.addMerchantFeeWallet.address.placeholder': '输入钱包地址',
  // Fund wallet consolidation translations
  'component.merchantConsolidation.addFundWalletFirst': '请先添加一个资金钱包以启用归集功能。',
  'component.merchantConsolidation.fundWallet.label': '资金归集到自设钱包',
  'component.merchantConsolidation.noFundWalletsMessage':
    '未配置归集资金钱包。请添加钱包以启用归集到自设钱包功能。',
  'component.merchantConsolidation.fundEnabledDescription': '将资金归集到自设钱包。',
  'component.merchantConsolidation.fundDisabledDescription': '当前已禁用。启用以归集到自设钱包。',
  'component.merchantConsolidation.manageFundWalletsButton': '管理资金钱包',
  'component.merchantConsolidation.manageFeeWalletsButton': '管理手续费钱包',
  'component.merchantConsolidation.feeDisabledDescription': '当前已禁用。启用以归集到自设钱包。',
  'component.merchantConsolidation.feeEnabledDescription': '将手续费归集到自设钱包。',

  // Fund wallet modal and form translations
  'component.addMerchantFundWallet.updateWallets.success': '资金钱包配置已成功更新',
  'component.addMerchantFundWallet.updateWallets.error': '更新资金钱包配置失败',
  'component.addMerchantFundWallet.modal.configureWalletsTitle': '配置资金钱包',
  'component.addMerchantFeeWallet.modal.configureWalletsTitle': '配置手续费钱包',
  'component.addMerchantFundWallet.modal.saveButton': '保存',
  'component.addMerchantFundWallet.warning.title': '重要安全提示',
  'component.addMerchantFundWallet.warning.description':
    '请仔细核对所有钱包地址。错误的地址将导致资金永久损失。',
  'component.addMerchantFundWallet.address.placeholder': '输入钱包地址',
  'component.addMerchantFundWallet.clickEditToChange': '点击编辑进行更改',
  'component.addMerchantFundWallet.notSet': '未设置。输入地址进行配置。',
  'component.addMerchantFeeWallet.notSet': '未设置。输入地址进行配置。',
};
